import { Injectable } from '@nestjs/common';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { RmAntiBioticsRepository } from '../rm-antibiotics-report.respository';
import { RmAntiBioticsAdapter } from '../dto/rm-antibiotics-report.adapter';
import { RmAntibioticsReportInfo } from '../dto/rm-antibiotics-report.dto';
import { Grn } from '../raw-material-grn.entity';
import { GrnItems } from '../raw-material-grn-items.entity';

@Injectable()
export class AntibioticsReportService {
    constructor(
        private repository: RmAntiBioticsRepository,
        private adapter: RmAntiBioticsAdapter
    ){} 

    async createAntiBioticsTest(info: RmAntibioticsReportInfo): Promise<CommonResponse>{
        const manager = new GenericTransactionManager();
        try{
            await manager.startTransaction();
            const convertedEntity = await this.adapter.convertDtoToEntity(info);
            const savedInfo = await manager.getCustomRepository(RmAntiBioticsRepository).save(convertedEntity);

            if(savedInfo){
                const updateGrn = await manager.getRepository(GrnItems).update({ grnItemId: savedInfo.grnItemId }, { isAntibioticsTestCompleted: true });
                if(updateGrn.affected){
                    manager.completeTransaction();
                    return new CommonResponse(true, 1111, 'Rm Antibiotics Testing Info updated successfully')
                }else {
                    throw new ErrorResponse(9999, 'Failed to update RM GRN');
                }
            }else {
                throw new ErrorResponse(9999, 'Failed to Create Details');
            }
        }catch(error) {
            manager.releaseTransaction();
            return error;
        }
    }
}